import _ from 'lodash';
import React from 'react';
import Acl from "../../tools/Acl";
import Droit from "../../tools/Droit";
import AclContext from "./AclContext";
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line react/prop-types
var AclProvider = function AclProvider(_ref) {
  var children = _ref.children,
    getDroit = _ref.getDroit;
  var _React$useState = React.useState(null),
    acl = _React$useState[0],
    setAcl = _React$useState[1];
  React.useEffect(function () {
    getDroit().then(function (droits) {
      var newAcl = new Acl();
      _.forEach(droits, function (droitParam) {
        var droit = new Droit(droitParam.objet, droitParam.nomObjet, droitParam.droit);
        newAcl.registerDroit(droit);
      });
      setAcl(newAcl);
    });
  }, [getDroit, setAcl]);
  if (!acl) {
    return null;
  }
  return /*#__PURE__*/_jsx(AclContext.Provider, {
    value: acl,
    children: children
  });
};
AclProvider.handledProps = [];
export default AclProvider;